import "./sidebar-divider.scss";

export default function SidebarDivider() {
  return <hr className="sidebar-divider" data-testid="sidebar-divider" aria-hidden="true" />;
}
